import { TicketUnitTypeCode } from '../../../@interfaces/ticket/ticket-unit-type';

export const TICKET_TYPE_LABELS: Record<TicketUnitTypeCode, string> = {
  count: '回数券',
  point: 'ポイント',
  time: '時間券',
  amount: '金額券',
};

/**
 * unitSuffixからチケットタイプ名を取得する
 * @param unitType - チケットの単位
 * @returns チケットタイプ名（例: "回数券", "ポイント券"）
 */
export const getTicketTypeByUnitType = (
  unitType: TicketUnitTypeCode
): string => {
  // unitTypeからチケットタイプ名を推定
  switch (unitType) {
    case 'count':
      return TICKET_TYPE_LABELS.count;
    case 'point':
      return TICKET_TYPE_LABELS.point;
    case 'time':
      return TICKET_TYPE_LABELS.time;
    case 'amount':
      return TICKET_TYPE_LABELS.amount;
    default:
      // デフォルトは回数券として扱う
      return TICKET_TYPE_LABELS.count;
  }
};
